import { jsx as _jsx } from "react/jsx-runtime";
import { edgeTypeMatrix } from '@iotv/datamodel';
import { TreeItem2 as TreeItem } from '@mui/x-tree-view';
import { useContext } from 'react';
import { AppMainViewContext } from '../../../../ContextProviders/AppContextProvider';
import { isAdminRole } from '../../../../helpers/access';
import { ObjectTree } from '../../../../v2/components/generic/ObjectTree/ObjectTreev2';
import { NavigationSkeleton } from '../../../common/NavigationSkeleton';
import { ContextMenu } from '../../ContextMenuV2/ContextMenu';
import { customerPropertyAreaPlacePath } from '../../TreeDefinitions/CustomerPropertyAreaPlaceTree';
const debug = process.env.REACT_APP_DEBUG && false;
export const AdminPropertyTree = ({ applicationData, transactionFunctions, contextCustomer, lastKey }) => {
    const key = `${lastKey}_Property`;
    const [{ userSelectedGroup }] = useContext(AppMainViewContext);
    const label = isAdminRole(userSelectedGroup) && contextCustomer !== undefined ? (_jsx(ContextMenu, { label: "Properties", hideDelete: true, popUpElement: null, contextObject: contextCustomer, edgeTypeIdFilter: [edgeTypeMatrix.Customer.Property.customerHasProperty.edgeTypeId], ascendentAccessor: { ascendentAccessor: null, contextObject: contextCustomer } })) : ('Properties');
    return (_jsx(TreeItem, { itemId: key, label: label, children: contextCustomer !== undefined ? (_jsx(ObjectTree, { nodeEdgeMapper: applicationData,
            queryPaths: [customerPropertyAreaPlacePath],
            contextObjects: [contextCustomer],
            transactionFunctions,
            hideTopStep: true,
            maintree_rightclick: true,
            selectedNodeIds: [],
            expanded: [],
            orderByName: true,
            maxVisibleNodes: 10 }, key)) : (_jsx(NavigationSkeleton, {}, key)) }, key));
};
